import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';
import styles from './NewVersionInfo.module.css';

export const BoltIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.4355 7.77784L7.8499 16.8685C7.50689 17.2317 7.02939 17.4375 6.52983 17.4375C5.26977 17.4375 4.39279 16.1854 4.82341 15.0012L6.1875 11.25H3.01166C1.96969 11.25 1.125 10.4053 1.125 9.36334C1.125 9.12332 1.1708 8.8855 1.25994 8.66265L3.87328 2.1293C4.2518 1.18301 5.16831 0.5625 6.1875 0.5625H10.6875C11.7762 0.5625 12.5297 1.64988 12.1475 2.66924L11.25 5.0625H15.2651C16.1542 5.0625 16.875 5.78329 16.875 6.67243C16.875 7.08349 16.7178 7.47899 16.4355 7.77784Z"
                fill="#72479E"/>
        </svg>

    );
};

export const AiIcon = ({ size = 24, className }) => {
    return (
        <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor"
                  d="M6.342 19.476a.5.5 0 0 1 0-.949l2.152-.717a.5.5 0 0 0 .316-.316l.717-2.152a.5.5 0 0 1 .949 0l.717 2.152a.5.5 0 0 0 .316.316l2.152.717a.5.5 0 0 1 0 .949l-2.152.717a.5.5 0 0 0-.316.316l-.717 2.152a.5.5 0 0 1-.949 0L8.81 20.51a.5.5 0 0 0-.316-.316zM13.513 13.71c-.684-.228-.684-1.195 0-1.423l2.475-.825a.75.75 0 0 0 .474-.474l.825-2.475c.228-.684 1.195-.684 1.423 0l.825 2.475c.075.224.25.4.475.474l2.475.825c.683.228.683 1.195 0 1.423l-2.475.825a.75.75 0 0 0-.475.475l-.825 2.475c-.228.683-1.195.683-1.423 0l-.825-2.475a.75.75 0 0 0-.474-.475zM1.684 7.95c-.912-.303-.912-1.593 0-1.897l2.803-.934a1 1 0 0 0 .632-.632l.934-2.803c.304-.912 1.594-.912 1.898 0l.934 2.803a1 1 0 0 0 .632.632l2.803.934c.912.304.912 1.594 0 1.898l-2.803.934a1 1 0 0 0-.632.632L7.95 12.32c-.304.912-1.594.912-1.898 0L5.12 9.517a1 1 0 0 0-.632-.632z"></path>
        </svg>
    );
};

const captions = {
    "ru": {
        CDOC: "Новая версия Конструктора документов",
        DESCRIPTION: "Создавайте шаблоны документов быстрее с использованием искусственного интеллекта",
        BUTTON: "Создать шаблон с AI"
    }
    , "en": {
        CDOC: "New version of Constructor of Documents",
        DESCRIPTION: "Create document templates faster with AI",
        BUTTON: "Create a template with AI"
    }
};

const closedAtKey = "newVersionInfoClosedAt";
const cdoc2Url = "https://beta.cdoc.yandex-team.ru/neurodoc?utm_source=cdoc";

export const NewVersionInfo = (props) => {
    const caption = captions[props.lang] ? captions[props.lang] : captions["ru"];
    const [showInfoContainer, setShowInfoContainer] = useState(false);
    const [href, setHref] = useState(cdoc2Url);
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.substring(1).split("/");
        const isIFrame = path[0] === "iframe";
        const isExternal = props.user?.isExternal;
        const login = props.user?.login;

        if (login && !isExternal && !isIFrame) {
            setShowInfoContainer(true);
        } else {
            setShowInfoContainer(false);
        }
    }, [props.user]);

    const onCloseClick = () => {
        localStorage.setItem(closedAtKey, new Date(Date.now()).toISOString());
        setShowInfoContainer(false);
    }

    return showInfoContainer ? <div className={styles.newVersionInfoContainer}>
        <div className={styles.innerContainer}>
            <BoltIcon/>
            <div className={styles.textBlock}>
                <div className={styles.textBlockTitle}>{caption.CDOC}</div>
                <div>{caption.DESCRIPTION}</div>
                <div>
                    <a className={styles.goToButton} href={href} rel="noreferrer" onClick={onCloseClick}>
                        <AiIcon size={18} className={styles.aiIcon}/>
                        {caption.BUTTON}
                    </a>
                </div>
            </div>
            <CloseIcon
                className={styles.closeIcon}
                onClick={onCloseClick}
                fontSize="small"
            />
        </div>
    </div> : null;
}
